module.exports = "/assets/a0a2cf29ab33c8b7b60568a858b93129.png";